import React, { useState,useRef } from "react";
import { signInWithGoogle, firebaseApp } from "../firebase";
import { getFirestore, collection, addDoc, query,where,getDocs,updateDoc } from "firebase/firestore";
import { auth } from "../firebase";
import ReCAPTCHA from "react-google-recaptcha";

import { TextField, Button, Paper, Typography, MenuItem, Select, InputLabel, FormControl, Box,  Radio,
  RadioGroup,
  FormControlLabel,
  FormLabel, } from "@mui/material";
  import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { mt } from "date-fns/locale";

function AddItemPopup({ open, onClose, onSave, item }) {
  const [formData, setFormData] = useState({
    salutation: "",
    firstName: "",
    surname: "",
    mobileNo: "",
    alternateContactNo: "",
    professionalEmail: "",
    personalEmail: "",
    dob: "",
    membershipCategory: "",
    resiAddress1: "",
    resiAddress2: "",
    city: "",
    pincode: "",
    gender: "",
    qualification: "",
    organisation: "",
    noOfEmployees: "",
    designation: "",
    experience: "",
    expertise: "",
    paymentRef: "",
    paymentAmount: "",
    linkedIn: "",
    facebook: "",
    instagram: "",
    referralSource: "",
    additionalComments: "",
    membershipStartDate: "",
    membershipEndDate: "",
    purposeOfJoining: ""
  });

  const [isSignedIn, setIsSignedIn] = useState(false);
  const [captchaValue, setCaptchaValue] = useState(null);
  const [errorMessage, setErrorMessage] = useState("");
  const captchaRef = useRef(null);

  /*const handleGoogleSignIn = async () => {
    if (!captchaValue) {
      setErrorMessage("Please verify that you are not a robot.");
      return;
    }
    
    try {
      const result = await signInWithGoogle();
      setFormData((prevFormData) => ({
        ...prevFormData,
        personalEmail: result.user.email
      }));
      setIsSignedIn(true);
      setErrorMessage(""); // Clear any previous error message
    } catch (error) {
      console.error("Google Sign-In Error:", error);
    }
  };*/
  

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSave = async (e) => {
    e.preventDefault();
  
    if (!captchaValue) {
      setErrorMessage("Please complete the ReCAPTCHA verification.");
      return;
    }
  
    const phoneRegex = /^[0-9]{10}$/;
    if (!phoneRegex.test(formData.mobileNo)) {
      alert("Mobile number must be 10 digits long.");
      return;
    }
  
    // Email validation: must match the pattern example@example.com
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    if (!emailRegex.test(formData.professionalEmail)) {
      alert("Please enter a valid professional email.");
      return;
    }
  
    if (formData.personalEmail && !emailRegex.test(formData.personalEmail)) {
      alert("Please enter a valid personal email.");
      return;
    }
  
    try {
      const db = getFirestore();
      const membersRef = collection(db, "MembershipMaster");
  
      // Step 1: Check if a document with the same personalEmail already exists
      const q = query(membersRef, where("personalEmail", "==", formData.personalEmail));
      const querySnapshot = await getDocs(q);
  
      if (!querySnapshot.empty) {
        // If document exists, update the existing one
        const docRef = querySnapshot.docs[0].ref;
        await updateDoc(docRef, {
          ...formData,
          status: "approved",
          id: docRef.id // Add the document ID to the data
        });
        alert("Member updated successfully!");
      } else {
        // Step 2: If it doesn't exist, add a new document
        const docRef = await addDoc(membersRef, {
          ...formData,
          status: "approved",
          id: "" // Temporarily add an empty id field
        });
  
        // After the document is added, update it to include the doc id as the 'id' field
        await updateDoc(docRef, {
          id: docRef.id // Update the document with its Firestore-generated ID
        });
  
        alert("Member added successfully!");
      }
  
      // Reset form data after save
      setFormData({
        salutation: "",
        firstName: "",
        surname: "",
        mobileNo: "",
        alternateContactNo: "",
        professionalEmail: "",
        personalEmail: "",
        dob: "",
        membershipCategory: "",
        resiAddress1: "",
        resiAddress2: "",
        city: "",
        pincode: "",
        gender: "",
        qualification: "",
        organisation: "",
        noOfEmployees: "",
        designation: "",
        experience: "",
        expertise: "",
        paymentRef: "",
        paymentAmount: "",
        linkedIn: "",
        facebook: "",
        instagram: "",
        referralSource: "",
        additionalComments: "",
        membershipStartDate: "",
        membershipEndDate: "",
        purposeOfJoining: ""
      });
      setIsSignedIn(false);
      setCaptchaValue(null);
      captchaRef.current.reset();
      setErrorMessage(null);

      onClose();

    } catch (error) {
      console.error("Error saving member:", error);
    }
  };
  

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>{'Add New Member'}</DialogTitle>
      <DialogContent>
        {/*{!isSignedIn && (
          <div>
          <Button
            variant="contained"
            color="primary"
            onClick={handleGoogleSignIn}
            sx={{ mb: 2, width: "100%" }}
          >
            Sign up with Google
          </Button>

          <ReCAPTCHA
            sitekey= {process.env.REACT_APP_SITE_KEY}
            onChange={(value) => setCaptchaValue(value)}
            sx={{ mb: 2, width: "100%" }}
          />

          {errorMessage && <Typography color="error">{errorMessage}</Typography>}
        </div>
        )}
        {isSignedIn && (*/}

            <FormControl fullWidth sx={{ mb: 2 }}>
              <InputLabel>Salutation</InputLabel>
              <Select
                name="salutation"
                value={formData.salutation}
                onChange={handleChange}
              >
                <MenuItem value="Mr">Mr</MenuItem>
                <MenuItem value="Ms">Ms</MenuItem>
                <MenuItem value="Mrs">Mrs</MenuItem>
                <MenuItem value="Mas">Mas</MenuItem>
                <MenuItem value="Jr">Jr</MenuItem>
                <MenuItem value="Sr">Sr</MenuItem>
              </Select>
            </FormControl>
            <TextField
              label="First Name"
              name="firstName"
              value={formData.firstName}
              onChange={handleChange}
              fullWidth
              required
              sx={{ mb: 2 }}
            />
            <TextField
              label="Surname"
              name="surname"
              value={formData.surname}
              onChange={handleChange}
              fullWidth
              required
              sx={{ mb: 2 }}
            />
            <TextField
              label="Mobile No"
              name="mobileNo"
              value={formData.mobileNo}
              onChange={handleChange}
              inputProps={{ maxLength: 10, pattern: '[0-9]*', inputMode: 'numeric' }}
              fullWidth
              required
              sx={{ mb: 2 }}
            />
            <TextField
              label="Alternate Contact No"
              name="alternateContactNo"
              value={formData.alternateContactNo}
              onChange={handleChange}
              inputProps={{ maxLength: 10, pattern: '[0-9]*', inputMode: 'numeric' }}
              fullWidth
              sx={{ mb: 2 }}
            />
            <TextField
              label="Professional Email"
              name="professionalEmail"
              value={formData.professionalEmail}
              onChange={handleChange}
              fullWidth
              required
              type="email"
              sx={{ mb: 2 }}
            />
            <TextField
              label="Personal Email"
              name="personalEmail"
              value={formData.personalEmail}
              onChange={handleChange}
              fullWidth
              required
              type="email"
              //InputProps={{ readOnly: true }}
              sx={{ mb: 2 }}
            />
            <TextField
              label="Date of Birth"
              name="dob"
              value={formData.dob}
              onChange={handleChange}
              fullWidth
              required
              type="date"
              InputLabelProps={{ shrink: true }}
              sx={{ mb: 2 }}
            />
            <FormControl fullWidth sx={{ mb: 2 }}>
              <InputLabel>Membership Category</InputLabel>
              <Select
                name="membershipCategory"
                value={formData.membershipCategory}
                onChange={handleChange}
                required
              >
                <MenuItem value="Individual Annual">Individual Annual</MenuItem>
                <MenuItem value="Individual (5 Years)">Individual (5 Years)</MenuItem>
                <MenuItem value="Student">Student</MenuItem>
                <MenuItem value="Institutional">Institutional</MenuItem>
                <MenuItem value="Industry/Corporate">Industry/Corporate</MenuItem>
              </Select>
            </FormControl>
            <TextField
              label="Membership Start Date"
              name="membershipStartDate"
              value={formData.membershipStartDate}
              onChange={handleChange}
              fullWidth
              required
              type="date"
              InputLabelProps={{ shrink: true }}
              sx={{ mb: 2 }}
            />
             <TextField
              label="Membership End Date"
              name="membershipEndDate"
              value={formData.membershipEndDate}
              onChange={handleChange}
              fullWidth
              required
              type="date"
              InputLabelProps={{ shrink: true }}
              sx={{ mb: 2 }}
            />
            <TextField
              label="Resi Address (Line 1)"
              name="resiAddress1"
              value={formData.resiAddress1}
              onChange={handleChange}
              fullWidth
              sx={{ mb: 2 }}
            />
            <TextField
              label="Resi Address (Line 2)"
              name="resiAddress2"
              value={formData.resiAddress2}
              onChange={handleChange}
              fullWidth
              sx={{ mb: 2 }}
            />
            <TextField
              label="City"
              name="city"
              value={formData.city}
              onChange={handleChange}
              fullWidth
              required
              sx={{ mb: 2 }}
            />
            <TextField
              label="Pincode"
              name="pincode"
              value={formData.pincode}
              onChange={handleChange}
              type="number"
              fullWidth
              required
              sx={{ mb: 2 }}
            />

            {/* Gender Selection */}
            <FormControl component="fieldset" sx={{ mb: 2 }}>
              <FormLabel component="legend">Gender</FormLabel>
              <RadioGroup
                name="gender"
                value={formData.gender}
                onChange={handleChange}
                row
              >
                <FormControlLabel
                  value="Male"
                  control={<Radio />}
                  label="Male"
                />
                <FormControlLabel
                  value="Female"
                  control={<Radio />}
                  label="Female"
                />
                <FormControlLabel
                  value="Do not want to specify"
                  control={<Radio />}
                  label="Do not want to specify"
                />
              </RadioGroup>
            </FormControl>

            {/* Qualification and Organisation */}
            <TextField
              label="Qualification (Starting with Highest)"
              name="qualification"
              value={formData.qualification}
              onChange={handleChange}
              fullWidth
              required
              sx={{ mb: 2 }}
            />
            <TextField
              label="Organisation"
              name="organisation"
              value={formData.organisation}
              onChange={handleChange}
              fullWidth
              required
              sx={{ mb: 2 }}
            />
            <TextField
              label="No of Employees in Organisation"
              name="noOfEmployees"
              value={formData.noOfEmployees}
              onChange={handleChange}
              type="number"
              fullWidth
              sx={{ mb: 2 }}
            />
            <TextField
              label="Designation"
              name="designation"
              value={formData.designation}
              onChange={handleChange}
              fullWidth
              sx={{ mb: 2 }}
            />
            <TextField
              label="Total Experience (in years)"
              name="experience"
              value={formData.experience}
              onChange={handleChange}
              type="number"
              fullWidth
              sx={{ mb: 2 }}
            />

            {/* Expertise Area Dropdown */}
            <FormControl fullWidth sx={{ mb: 2 }}>
              <InputLabel>Area of Expertise/Work</InputLabel>
              <Select
                name="expertise"
                value={formData.expertise}
                onChange={handleChange}
                required
              >
                <MenuItem value="HR/Admin">HR/Admin</MenuItem>
                <MenuItem value="Finance/Accts">Finance/Accts</MenuItem>
                <MenuItem value="Marketing/Sales">Marketing/Sales</MenuItem>
                <MenuItem value="Materials/Supply Chain">Materials/Supply Chain</MenuItem>
                <MenuItem value="Operations/Manufacturing">Operations/Manufacturing</MenuItem>
                <MenuItem value="IT/ITES">IT/ITES</MenuItem>
                <MenuItem value="Agriculture">Agriculture</MenuItem>
                <MenuItem value="Hospitality">Hospitality</MenuItem>
                <MenuItem value="Healthcare">Healthcare</MenuItem>
                <MenuItem value="Travel/Tourism">Travel/Tourism</MenuItem>
                <MenuItem value="Trading/Exports">Trading/Exports</MenuItem>
                <MenuItem value="Consultancy">Consultancy</MenuItem>
                <MenuItem value="Corporate Training">Corporate Training</MenuItem>
                <MenuItem value="Higher Education/Academics">Higher Education/Academics</MenuItem>
                <MenuItem value="School Education">School Education</MenuItem>
                <MenuItem value="Social Work">Social Work</MenuItem>
                <MenuItem value="Media/Entertainment">Media/Entertainment</MenuItem>
                <MenuItem value="Quality">Quality</MenuItem>
                <MenuItem value="Engineering">Engineering</MenuItem>
                <MenuItem value="Other">Other</MenuItem>
              </Select>
            </FormControl>

            {/* Payment Amount */}
            <TextField
              label="Payment Amount"
              name="paymentAmount"
              value={formData.paymentAmount}
              onChange={handleChange}
              fullWidth
              type="number"
              sx={{ mb: 2 }}
            />

            {/* Fees Payment Details/Ref number */}
            <TextField
              label="Payment Reference"
              name="paymentRef"
              value={formData.paymentRef}
              onChange={handleChange}
              fullWidth
              sx={{ mb: 2 }}
            />

            {/* Social Media Links */}
            <TextField
              label="LinkedIn Profile"
              name="linkedIn"
              value={formData.linkedIn}
              onChange={handleChange}
              fullWidth
              sx={{ mb: 2 }}
            />
            <TextField
              label="Facebook Profile"
              name="facebook"
              value={formData.facebook}
              onChange={handleChange}
              fullWidth
              sx={{ mb: 2 }}
            />
            <TextField
              label="Instagram Profile"
              name="instagram"
              value={formData.instagram}
              onChange={handleChange}
              fullWidth
              sx={{ mb: 2 }}
            />

            {/* Referral Source Dropdown */}
            <FormControl fullWidth sx={{ mb: 2 }}>
              <InputLabel>How Did You Come to Know About Us?</InputLabel>
              <Select
                name="referralSource"
                value={formData.referralSource}
                onChange={handleChange}
                required
              >
                <MenuItem value="WhatsApp">WhatsApp</MenuItem>
                <MenuItem value="News paper">News paper</MenuItem>
                <MenuItem value="Social Media">Social Media</MenuItem>
                <MenuItem value="Referral from existing Member">
                  Referral from existing Member
                </MenuItem>
                <MenuItem value="Any other">Any other</MenuItem>
              </Select>
            </FormControl>

            {/* Additional Comments */}
            <TextField
              label="Additional Comments / Remarks"
              name="additionalComments"
              value={formData.additionalComments}
              onChange={handleChange}
              fullWidth
              multiline
              rows={4}
              sx={{ mb: 2 }}
            />

            {/* Purpose of Joining */}
            <TextField
              label="Purpose of Joining"
              name="purposeOfJoining"
              value={formData.purposeOfJoining}
              onChange={handleChange}
              fullWidth
              multiline
              rows={2}
              sx={{ mb: 2 }}
            />

          <ReCAPTCHA
            ref={captchaRef} // Attach the ref to reCAPTCHA
            sitekey={process.env.REACT_APP_SITE_KEY}
            onChange={(value) => setCaptchaValue(value)}
            sx={{ mb: 2, width: "100%", mt:3 }}
          />

          {errorMessage && <Typography color="error">{errorMessage}</Typography>}
          </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button onClick={handleSave}>Save</Button>
      </DialogActions>
    </Dialog>
  );
}

export default AddItemPopup;
